import { render, staticRenderFns } from "./ProposalData.vue?vue&type=template&id=43102055&scoped=true&"
import script from "./ProposalData.vue?vue&type=script&lang=js&"
export * from "./ProposalData.vue?vue&type=script&lang=js&"
import style0 from "./ProposalData.vue?vue&type=style&index=0&id=43102055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43102055",
  null
  
)

export default component.exports